// Language Selector Component
// Displays available languages and allows switching between them

import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getConfig } from '../config/gameConfig';

// Available languages configuration
const AVAILABLE_LANGUAGES = [
    { code: 'el', label: 'ΕΛ', fullName: 'Ελληνικά' },
    { code: 'en', label: 'EN', fullName: 'English' }
];

export default function LanguageSelector() {
    const { languageCode, changeLanguage } = useLanguage();
    
    // Don't render if the feature is disabled in config
    if (!getConfig('showLanguageSelector')) {
        return null;
    }

    const handleLanguageChange = (langCode) => {
        if (langCode !== languageCode) {
            changeLanguage(langCode);
        }
    };

    return (
        <div style={{
            position: 'absolute',
            bottom: '20px',
            left: '20px',
            zIndex: 100,
            display: 'flex',
            gap: '10px',
            alignItems: 'center'
        }}>
            {AVAILABLE_LANGUAGES.map((lang) => (
                <button
                    key={lang.code}
                    onClick={() => handleLanguageChange(lang.code)}
                    title={lang.fullName}
                    style={{
                        padding: '8px 16px',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        border: '2px solid',
                        borderColor: languageCode === lang.code ? '#FFD700' : '#ffffff',
                        borderRadius: '6px',
                        background: languageCode === lang.code 
                            ? 'rgba(255, 215, 0, 0.2)' 
                            : 'rgba(0, 0, 0, 0.5)',
                        color: languageCode === lang.code ? '#FFD700' : '#ffffff',
                        cursor: languageCode === lang.code ? 'default' : 'pointer',
                        transition: 'all 0.3s ease',
                        backdropFilter: 'blur(5px)',
                        outline: 'none',
                        opacity: languageCode === lang.code ? 1 : 0.7,
                        transform: languageCode === lang.code ? 'scale(1.05)' : 'scale(1)',
                        boxShadow: languageCode === lang.code 
                            ? '0 0 10px rgba(255, 215, 0, 0.5)' 
                            : 'none'
                    }}
                    onMouseEnter={(e) => {
                        if (languageCode !== lang.code) {
                            e.currentTarget.style.opacity = '1';
                            e.currentTarget.style.borderColor = '#FFD700';
                            e.currentTarget.style.transform = 'scale(1.05)';
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (languageCode !== lang.code) {
                            e.currentTarget.style.opacity = '0.7';
                            e.currentTarget.style.borderColor = '#ffffff';
                            e.currentTarget.style.transform = 'scale(1)';
                        }
                    }}
                >
                    {lang.label}
                </button>
            ))}
        </div>
    );
}

